import { render, staticRenderFns } from "./FarmerCollect.vue?vue&type=template&id=911f79bc&scoped=true"
import script from "./FarmerCollect.vue?vue&type=script&lang=js"
export * from "./FarmerCollect.vue?vue&type=script&lang=js"
import style0 from "./FarmerCollect.vue?vue&type=style&index=0&id=911f79bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911f79bc",
  null
  
)

export default component.exports